export default __webpack_public_path__ + "static/media/robotoslab-regular.14803206.ttf";